module.exports = __webpack_public_path__ + "static/media/loader-example.3886920c.gif";